import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
} from "@chakra-ui/react";
import FormInput from "./FormInput";
import PrimaryButton from "./PrimaryButton";
import PrimaryHeading from "./PrimaryHeading";
import ErrorAlert from "./ErrorAlert";

const DateRangeModal = ({ isOpen, onClose, onApply }) => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleApply = () => {
    if (!fromDate || !toDate) {
      setErrorMessage("Both 'From Date' and 'To Date' must be selected.");
      return;
    }

    if (new Date(fromDate) > new Date(toDate)) {
      setErrorMessage("'To Date' cannot be earlier than 'From Date'.");
      return;
    }

    setErrorMessage("");
    onApply({ fromDate, toDate });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <PrimaryHeading>Date Range Filter</PrimaryHeading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex direction="column" gap={4}>
            <FormInput
              type="date"
              placeholder="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <FormInput
              type="date"
              placeholder="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
            {errorMessage && <ErrorAlert message={errorMessage} />}
          </Flex>
        </ModalBody>
        <ModalFooter>
          <PrimaryButton onClick={handleApply}>Apply</PrimaryButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DateRangeModal;
